( function( factory ) {
	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define( [ "jquery" ], factory );
	} else {

		// Browser globals
		factory( jQuery );
	}
} ( function( $ ) {

$.ui = $.ui || {};

return $.ui.version = "1.12.1";

} ) );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery-ui/ui/version.js
 ** module id = 318
 ** module chunks = 0
 **/